const simpleCalculation = {
  logic (condition, leftValue, rightValue, type) {
    if (type === 'decimal') {
      rightValue = parseFloat(rightValue)
    } else if (type.indexOf('date') >= 0) {
      rightValue = new Date(rightValue)
    }
    let state = false
    switch (condition) {
      case '=':
        state = leftValue === rightValue
        break
      case '!=':
        state = leftValue !== rightValue
        break
      case '>':
        state = leftValue > rightValue
        break
      case '>=':
        state = leftValue >= rightValue
        break
      case '<':
        state = leftValue < rightValue
        break
      case '<=':
        state = leftValue <= rightValue
        break
      default:
        throw new Error('未知的比较类型')
    }
    return state
  }
}

export {simpleCalculation}



// WEBPACK FOOTER //
// ./src/components/report/runtime/simpleCalculation.js